var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center rwloader2 mt-2"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }